import { h, Component, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import getIsMobile from 'ismobilejs';
import { get as getConfiguration } from './configuration';
import messages from './i18n/de.json';
import { persistConsentStatus } from './consent-cookie-status';
import {
  createBlocker,
  enableBlocker,
  disableBlocker,
} from './interactions-blocker';

const Status = {
  NotAnswered: 'notAnswered',
  Accepted: 'accepted',
  Denied: 'denied',
  OptingIn: 'OptingIn',
};

const getWrapperStyles = () => ({});
const getBannerStyles = ({ isMobile }) => ({
  display: 'flex',
  'justify-content': 'space-between',
  padding: '1em',
  'font-family': 'Verdana, Sans-Serif',
  color: '#fff',
  background: 'rgba(0,0,0,.7)',
  color: '#fafafa',
  ...(isMobile && { flexFlow: 'column' }),
});
const getTextStyles = () => ({
  'align-self': 'center',
  color: '#fff',
});
const getTextColorStyles = () => ({
  color: '#fff',
});
const getListStyles = () => ({
  'align-self': 'center',
  'list-style-type': 'circle',
  color: '#fff',
  margin: '0 2em',
});
const getDescriptionsStyles = ({ isMobile }) => ({
  //...(!isMobile && { flex: '1 1 50em' }),
  color: '#fff',
});
const getOptingInOptionsStyles = () => ({
  display: 'flex',
  'justify-content': 'space-between',
  'flex-direction': 'row',
});
const getOptingInDescriptionStyles = () => ({
  margin: '0 0 1em 0',
  padding: 0,
  'font-size': '85%',
});
const getLinksStyles = ({ isMobile }) => ({
  display: 'flex',
  'flex-flow': 'column',
  'justify-content': 'center',
  whitespace: 'nowrap',
  opacity: 0.8,
  color: '#fff',
  'font-size': '85%',
  ...(!isMobile && { padding: '0 3em' }),
});
const getActionStyles = ({ isMobile }) => ({
  display: 'flex',
  margin: '1em 0',
  'align-items': 'flex-start',
  ...(isMobile && {
    'flex-direction': 'row',
    'justify-content': 'space-between',
  }),
  ...(!isMobile && { flex: '0 1 70em' }),
});
const getButtonsStyles = ({ isMobile }) => ({
  'max-width': '15em',
});
const getLinkStyles = ({ isDelay }) => ({
  color: 'inherit',
  ...(isDelay && { 'font-weight': 'bold' }),
});
const getAcceptStyles = ({ isMobile }) => ({
  'font-family': 'Verdana, Sans-Serif',
  display: 'inline-block',
  'font-weight': 'bold',
  'min-width': '15em',
  'max-height': '4em',
  'min-height': '4em',
  padding: '0 2em',
  background: '#38e',
  'border-radius': '4px',
  cursor: 'pointer',
  color: '#fff',
  'font-size': '100%',
});
const getOptingInStyles = ({ isMobile, isOptingOut }) => ({
  display: 'flex',
  'align-items': 'center',
  'align-self': 'center',
  'max-height': '3em',
  'min-height': '3em',
  padding: '0 2em',
  margin: '0 1em 0 0',
  'border-radius': '4px',
  'text-transform': 'uppercase',
  cursor: 'pointer',
  color: '#fff',
  'font-size': '80%',
  ...(!isOptingOut && { background: '#38e' }),
  ...(isOptingOut && { background: 'inherit' }),
});

const ConsentSlideOut = (props) => {
  const isMobile = getIsMobile().any;
  const [status, setStatus] = useState(Status.NotAnswered);
  const [isMoreInformationVisible, setMoreInformationVisibility] = useState(
    false
  );

  useEffect(() => {
    createBlocker();
    enableBlocker();

    return () => removeBlocker();
  }, []);

  const hasStatus = (expectedStatus) => expectedStatus === status;

  const handleAccept = () => {
    persistConsentStatus({ status: Status.Accepted, expires: 30 });
    setStatus(Status.Accepted);

    disableBlocker();
  };

  const handleOptingIn = () => {
    setStatus(Status.OptingIn);
  };

  const handleOptOut = () => {
    setStatus(Status.NotAnswered);
  };

  const handleDelay = () => {
    persistConsentStatus({ status: Status.Accepted, expires: 1 });
    setStatus(Status.Accepted);

    disableBlocker();
  };

  const handleDeny = () => {
    persistConsentStatus({ status: Status.Denied });
    setStatus(Status.Denied);

    disableBlocker();
  };

  const handleShowMoreInformation = () => {
    setMoreInformationVisibility(true);
  };

  const handleShowLessInformation = () => {
    setMoreInformationVisibility(false);
  };

  const hasMadeChoice = hasStatus(Status.Accepted) || hasStatus(Status.Denied);

  return (
    <div style={getWrapperStyles()}>
      {!hasMadeChoice && (
        <div style={getBannerStyles({ isMobile })}>
          <div style={getDescriptionsStyles({ isMobile })}>
            <span style={getTextStyles()}>
              <p style={getTextColorStyles()}>{messages.description1}</p>
              <p style={getTextColorStyles()}>{messages.description2}</p>
            </span>
            {isMoreInformationVisible && (
              <span>
                <h4>{messages.moreInfoTitle}</h4>
                <ul style={getListStyles()}>
                  <li style={getTextColorStyles()}>
                    {messages.moreInfoServices1}
                  </li>
                  <li style={getTextColorStyles()}>
                    {messages.moreInfoServices2}
                  </li>
                  <li style={getTextColorStyles()}>
                    {messages.moreInfoServices3}
                  </li>
                </ul>
                <p>{messages.moreInfoOptingOut}</p>
              </span>
            )}
          </div>
          <div style={getActionStyles({ isMobile })}>
            <span style={getLinksStyles({ isMobile })}>
              <a
                style={getLinkStyles({ isDelay: false })}
                target="newPricayPolicy"
                href={getConfiguration('disclaimerLink')}
              >
                {messages.disclaimerTitle}
              </a>
              <a
                style={getLinkStyles({ isDelay: false })}
                href="#"
                onClick={
                  isMoreInformationVisible
                    ? handleShowLessInformation
                    : handleShowMoreInformation
                }
              >
                {isMoreInformationVisible
                  ? messages.lessInfoTitle
                  : messages.moreInfoTitle}
              </a>
              <a
                style={getLinkStyles({ isDelay: true })}
                href="#"
                onClick={handleDelay}
              >
                {messages.delay}
              </a>
            </span>
            <span style={getButtonsStyles({ isMobile })}>
              {(() => {
                if (hasStatus(Status.NotAnswered))
                  return (
                    <button
                      style={getAcceptStyles({ isMobile })}
                      onClick={handleOptingIn}
                    >
                      {messages.accept}
                    </button>
                  );
                else if (hasStatus(Status.OptingIn))
                  return (
                    <Fragment>
                      <p style={getOptingInDescriptionStyles({ isMobile })}>
                        {messages.optInDescription}
                      </p>
                      <div style={getOptingInOptionsStyles({ isMobile })}>
                        <button
                          style={getOptingInStyles({ isMobile })}
                          onClick={handleAccept}
                        >
                          {messages.optIn}
                        </button>
                        <button
                          style={getOptingInStyles({
                            isMobile,
                            isOptingOut: true,
                          })}
                          onClick={handleOptOut}
                        >
                          {messages.optOut}
                        </button>
                      </div>
                    </Fragment>
                  );
              })()}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsentSlideOut;
